// return adaptMoreLen(state, getters, rootState);
import SearchTag from '@/common/search-tag-list';
// import { searchCenter } from './isSearchCenter';
import { mobileOutFields, brokerMobileOutFields } from '../_util';
import { acreToSqft } from '@/common/utils/acre-sqft';
function getSuggestionValue(valueArr) {
    return valueArr.reduce((memo, val) => {
        const [type, value] = val.split(':');
        memo[type] || (memo[type] = []);
        memo[type].push(value);
        return memo;
    }, {});
}

const processApiParams = {
    mapPath(searchData, mapCondition) {
        if (mapCondition.mapPath) {
            searchData['location'] = {
                mapPath: JSON.parse(mapCondition.mapPath).map(o =>
                    JSON.stringify(o)
                )
            };
        }
        return searchData;
    },
    keywords(searchData, state) {
        if (state.keywords.length) {
            const obj = state.keywords.reduce((acc, cur) => {
                acc[cur.keywordType] || (acc[cur.keywordType] = []);
                acc[cur.keywordType].push(cur.keyword);
                return acc;
            }, {});
            searchData['location'] = obj;
        }
        return searchData;
    },
    conditionArr(searchData, state) {
        const conditions = state.conditions;
        Object.entries(conditions).forEach(([name, o]) => {
            let { value, inputType } = o;
            if (name === 'location') return;
            if (inputType === 'suggestion') {
                value = getSuggestionValue(value);
            }

            const ui = state.uiConfig[name];
            const { sqft } = ui || {};
            if (sqft === 'acre' && value) {
                const [v1, v2] = value.split(',');
                value = `${acreToSqft(v1)},${acreToSqft(v2)}`;
            }
            searchData[name] = value;
        });
        return searchData;
    }
};
const calcTagsCount = (state, getters, exclude = []) => {
    const searchConfigMap = state.searchConfigMap;
    let allCondition = getters.allConditions;
    allCondition = allCondition.reduce((memo, cur) => {
        if (exclude.includes(cur.dn)) return memo;
        memo[cur.dn] = cur.values;
        return memo;
    }, {});
    const tag = new SearchTag(allCondition, null, searchConfigMap);
    return tag.getTagSync().length;
};

const getters = {
    mobileFilterCount: (state, getters, rootState) => {
        let count = 0;
        Object.values(state.conditions).forEach(cond => {
            if (!mobileOutFields.includes(cond.kee)) {
                count += cond.labels.filter(label => !!label).length;
            }
        });
        return count;
        // return adaptMobileFilterCount(state, getters, rootState);
    },
    brokerFilterCount: (state, getters, rootState) => {
        let count = 0;
        Object.values(state.conditions).forEach(cond => {
            if (!brokerMobileOutFields.includes(cond.kee)) {
                count += cond.labels.filter(label => !!label).length;
            }
        });
        return count;
        // return adaptMobileFilterCount(state, getters, rootState);
    },
    allConditions(state, getters) {
        let allConditions = [];
        let conditions = state.conditions;
        if (state.keywords.length) {
            let obj = {
                dn: 'key',
                split: ';',
                values: [],
                labels: []
            };
            state.keywords.forEach(keyword => {
                obj.values.push(keyword.keywordType + ':' + keyword.keyword);
                obj.labels.push(keyword.keyword);
            });
            allConditions.push(obj);
        }

        if (state.mapCondition.mapPath) {
            allConditions.push({
                dn: 'mapPath',
                values: [state.mapCondition.mapPath],
                labels: ['Custom Boundary']
            });
        }

        if (state.mapCondition.mapSearch) {
            allConditions.push({
                dn: 'mapSearch',
                values: [true],
                labels: ['Map Area'],
                rect: state.mapCondition.rect
            });
        }
        Object.keys(conditions).forEach(key => {
            let item = conditions[key];
            if (!item.value) {
                return;
            }
            allConditions.push({
                dn: item.kee,
                values:
                    typeof item.value === 'string'
                        ? item.value.split(item.split || ',')
                        : [item.value],
                labels: item.labels
            });
        });
        return allConditions;
    },
    moreLen: (state, getters, rootState) => {
        let len = 0;
        const conditions = state.conditions;
        Object.values(conditions).forEach(cond => {
            if (cond.inMore) {
                if (cond.type === 'tag-input') {
                    len += cond.value
                        .split(cond.split)
                        .filter(label => !!label).length;
                } else {
                    len += cond.labels.filter(label => !!label).length;
                }
            }
        });
        return len;
    },
    searchParams: state => {
        let params = {
            listingSource: state.listingSource
        };
        if (state.keywords.length) {
            const SPLIT = ';';
            params.key = state.keywords.map(obj => obj.keyword).join(SPLIT);
            params.keywordType = state.keywords
                .map(obj => obj.keywordType)
                .join(SPLIT);
        }
        Object.keys(state.conditions).forEach(kee => {
            let value = state.conditions[kee].value;
            if (!value) {
                return;
            }
            params[kee] = state.conditions[kee].value;
        });
        return params;
    },
    searchParamsWithMap(state, getters) {
        const ret = { ...getters.searchParams };
        if (state.mapCondition.mapPath) {
            ret.mapPath = state.mapCondition.mapPath;
        }
        if (state.mapCondition.mapSearch) {
            ret.mapSearch = state.mapCondition.mapSearch;
            ret.rect = state.mapCondition.rect;
        }
        return ret;
    },
    filterCount: (state, getters, rootState) => {
        let count = state.keywords.length;
        if (state.mapCondition.mapPath) {
            count++;
        }
        Object.values(state.conditions).forEach(cond => {
            count += cond.labels.filter(label => !!label).length;
        });
        return count;
    }
};

const centerGetters = {
    allConditions(state, getters) {
        let allConditions = [];
        let conditions = state.conditions;
        if (state.keywords.length) {
            let obj = {
                dn: 'key',
                split: ';',
                values: [],
                labels: []
            };
            state.keywords.forEach(keyword => {
                obj.values.push(keyword.keywordType + ':' + keyword.keyword);
                obj.labels.push(keyword.keyword);
            });
            allConditions.push(obj);
        }

        if (state.mapCondition.mapPath) {
            allConditions.push({
                dn: 'mapPath',
                values: [state.mapCondition.mapPath],
                labels: ['Custom Boundary']
            });
        }

        if (state.mapCondition.mapSearch) {
            allConditions.push({
                dn: 'mapSearch',
                values: [true],
                labels: ['Map Area'],
                rect: state.mapCondition.rect
            });
        }
        Object.entries(conditions).forEach(([name, o]) => {
            let values;
            if (o.inputType === 'suggestion') {
                values = getSuggestionValue(o.value);
            } else {
                values = o.value;
            }
            allConditions.push({
                dn: name,
                values
            });
        });
        return allConditions;
    },
    mobileFilterCount: (state, getters, rootState) => {
        let count = 0;
        const exclude = [
            'location',
            'key',
            'mapPath',
            'mapSearch',
            ...state.outsideFields.slice(0, 3)
        ];
        count += calcTagsCount(state, getters, exclude);
        return count;
        // return adaptMobileFilterCount(state, getters, rootState);
    },
    moreLen: (state, getters, rootState) => {
        const exclude = [
            ...state.outsideFields,
            'location',
            'key',
            'mapPath',
            'mapSearch'
        ];
        return calcTagsCount(state, getters, exclude);
        // return adaptMoreLen(state, getters, rootState);
    },
    filterCount: (state, getters, rootState) => {
        let count = state.keywords.length;
        if (state.mapCondition.mapPath) {
            count++;
        }
        const exclude = ['location', 'key', 'mapPath', 'mapSearch'];
        count += calcTagsCount(state, getters, exclude);
        return count;
        // return adaptFilterCount(state, getters, rootState);
    },

    searchParams: state => {
        let params = {
            listingSource: state.listingSource
        };
        let searchData = {};
        const mapCondition = JSON.parse(JSON.stringify(state.mapCondition));
        if (state.keywords.length > 0) {
            searchData = processApiParams.keywords(searchData, state);
        } else {
            searchData = processApiParams.mapPath(searchData, mapCondition);
        }
        delete mapCondition.mapPath;
        searchData = processApiParams.conditionArr(searchData, state);
        params.condition = JSON.stringify(searchData);
        params.uiConfig = JSON.stringify(state.uiConfig || {});
        Object.assign(params, mapCondition);
        return params;
    },
    searchParamsWithMap: (state, getters) => {
        const ret = { ...getters.searchParams };
        if (!state.mapCondition.mapSearch) {
            delete ret.mapSearch;
            delete ret.rect;
        }
        delete ret.threshold;
        return ret;
    }
};

export default ({ searchCenter }) => {
    return {
        isMobileSize(state, getters, rootState) {
            const windowSize = rootState.common.windowSize;
            const width = windowSize.width || 0;
            return width <= 800;
        },
        ...(searchCenter ? centerGetters : getters)
    };
};
